// src/utils/loadingModal.js
import { Button, Modal, Spin } from 'antd';
import style from './loadingModalStyle.m.less';

export const submitLoadingModal = () => {
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        width: 560,
        className: style['submit-loading-dialog'],
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <Spin/>
            <div style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 1)' ,marginTop: '20px'}}>交卷中，请稍后...</div>

        </div>
    });
};

export const examTimeFinishModal = () => {
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        width: 560,
        className: style['submit-finish-dialog'],
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <div style={{
                textAlign: 'left',
                fontSize: '16px',
                color: 'rgba(51, 51, 51, 1)',
                fontWeight: '500',
                paddingBottom: '16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
                提示
            </div>
            <img src={require('../../../assets/images/exam/exam_time_finish.webp')} alt={null} style={{
                width: '180px',
                height: '180px',
                marginTop: '48px'
            }}/>
            <div style={{ fontSize: '16px',color: 'rgba(67, 67, 67, 1)' }}>考试时间已结束</div>
            <div style={{ fontSize: '16px',color: 'rgba(67, 67, 67, 1)', marginBottom: '12px' }}>即将为您自动提交试卷…</div>
        </div>
    });
};

export const examSubmitSuccessModal = (onKnown) => {
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        width: 560,
        className: style['submit-finish-dialog'],
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <div style={{
                textAlign: 'left',
                fontSize: '16px',
                color: 'rgba(51, 51, 51, 1)',
                fontWeight: '500',
                paddingBottom: '16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
                提示
            </div>
            <img src={require('../../../assets/images/exam/exam_submit_success.webp')} alt={null} style={{
                width: '180px',
                height: '180px',
                marginTop: '48px'
            }} />
            <div style={{
                fontSize: '16px',
                color: 'rgba(67, 67, 67, 1)'
            }}>交卷成功</div>
            <Button style={{
                width: '224px',
                borderRadius: '8px',
                position: 'absolute',
                bottom: '24px',
                left: '50%',
                transform: 'translateX(-50%)'
            }} type='primary' onClick={() => {
                Modal.destroyAll();
                onKnown();
            }}>知道了</Button>
        </div>
    });
};

export const examSubmitRepeatModal = (templateId, onKnown) => {
    let tips = '您已提交过试卷，请勿重复提交，有疑问请联系管理员';
    switch (templateId) {
        case 102:
        case '102': //考试
            tips = '您已提交过试卷，请勿重复提交，有疑问请联系管理员';
            break;
        case 105:
        case '105': //作业
            tips = '您已提交过本次作业，请勿重复提交，有疑问请联系管理员';
            break;
        case 106:
        case '106': //研修成果
            tips = '您已提交过本次研修成果，请勿重复提交，有疑问请联系管理员';
            break;
    }
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        width: 560,
        className: style['submit-finish-dialog'],
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <div style={{
                textAlign: 'left',
                fontSize: '16px',
                color: 'rgba(51, 51, 51, 1)',
                fontWeight: '500',
                paddingBottom: '16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
                提示
            </div>
            <img src={require('../../../assets/images/exam/exam_submit_failed.webp')} alt={null} style={{
                width: '180px',
                height: '180px',
                marginTop: '48px'
            }} />
            <div style={{
                fontSize: '16px',
                color: 'rgba(67, 67, 67, 1)'
            }}>{tips}
            </div>
            <Button style={{
                width: '224px',
                borderRadius: '8px',
                position: 'absolute',
                bottom: '24px',
                left: '50%',
                transform: 'translateX(-50%)'
            }} type='primary' onClick={() => {
                Modal.destroyAll();
                onKnown();
            }}>知道了</Button>
        </div>
    });
};

export const examSubmitFailedModal = (onKnown) => {
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        width: 560,
        className: style['submit-finish-dialog'],
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <div style={{
                textAlign: 'left',
                fontSize: '16px',
                color: 'rgba(51, 51, 51, 1)',
                fontWeight: '500',
                paddingBottom: '16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
                提示
            </div>
            <img src={require('../../../assets/images/exam/exam_submit_failed.webp')} alt={null} style={{
                width: '180px',
                height: '180px',
                marginTop: '48px'
            }} />
            <div style={{
                fontSize: '16px',
                color: 'rgba(67, 67, 67, 1)'
            }}>交卷失败，有疑问请联系管理员
            </div>
            <Button style={{
                width: '224px',
                borderRadius: '8px',
                position: 'absolute',
                bottom: '24px',
                left: '50%',
                transform: 'translateX(-50%)'
            }} type='primary' onClick={() => {
                Modal.destroyAll();
                onKnown();
            }}>知道了</Button>
        </div>
    });
};

export const examCutScreenMaxModal = (currNum, maxNum) => {
    Modal.info({
        icon: null,
        onCancel: null,
        closable: false,
        title: null,
        footer: null,
        className: style['submit-finish-dialog'],
        width: 560,
        centered: true,
        maskClosable: false,
        content: <div style={{ textAlign: 'center', padding: '16px', marginBottom: '8px' }}>
            <div style={{
                textAlign: 'left',
                fontSize: '16px',
                color: 'rgba(51, 51, 51, 1)',
                fontWeight: '500',
                paddingBottom: '16px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
            }}>
                提示
            </div>
            <img src={require('../../../assets/images/exam/cut_screen_submit_before.webp')} alt={null} style={{
                width: '180px',
                height: '180px',
                marginTop: '48px'
            }} />
            <div style={{
                fontSize: '16px',
                color: 'rgba(67, 67, 67, 1)'
            }}>{`本次考试最多切屏${maxNum}次，您已经切屏${currNum}次`}</div>
            <div style={{
                fontSize: '16px',
                color: 'rgba(67, 67, 67, 1)'
            }}>即将为您自动提交试卷…</div>
        </div>
    });
};


